var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { CUSTOM_CONTENT_NOTIFICATION_GET_ERROR_ACTION_TYPE, CUSTOM_CONTENT_NOTIFICATION_GET_START_ACTION_TYPE, CUSTOM_CONTENT_NOTIFICATION_GET_SUCCESS_ACTION_TYPE, CUSTOM_CONTENT_NOTIFICATION_UPDATE_ERROR_ACTION_TYPE, CUSTOM_CONTENT_NOTIFICATION_UPDATE_START_ACTION_TYPE, CUSTOM_CONTENT_NOTIFICATION_UPDATE_SUCCESS_ACTION_TYPE } from "../action/CustomContentNotificationsActionsTypes";
import { CustomContentNotificationStatus } from "./CustomContentNotificationsState";
var initialState = {
    status: CustomContentNotificationStatus.Initial,
    customContentNotification: null,
    loading: false,
    error: null,
};
export var CustomContentNotificationReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case CUSTOM_CONTENT_NOTIFICATION_GET_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: CustomContentNotificationStatus.Getting, loading: true });
        case CUSTOM_CONTENT_NOTIFICATION_GET_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: CustomContentNotificationStatus.GetSuccess, customContentNotification: action.payload.customContentNotification, loading: false });
        case CUSTOM_CONTENT_NOTIFICATION_GET_ERROR_ACTION_TYPE:
            return __assign(__assign({}, state), { status: CustomContentNotificationStatus.GetError, loading: false, error: action.payload.error });
        case CUSTOM_CONTENT_NOTIFICATION_UPDATE_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: CustomContentNotificationStatus.Updating, loading: true });
        case CUSTOM_CONTENT_NOTIFICATION_UPDATE_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: CustomContentNotificationStatus.UpdateSuccess, customContentNotification: action.payload.customContentNotification, loading: false });
        case CUSTOM_CONTENT_NOTIFICATION_UPDATE_ERROR_ACTION_TYPE:
            return __assign(__assign({}, state), { status: CustomContentNotificationStatus.UpdateError, loading: false, error: action.payload.error });
        default:
            return state;
    }
};
export default CustomContentNotificationReducer;
